import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, ArkUnitOfWork, AuthService } from '../../core/core.module';
import _ from 'lodash';
import { Committee, CommitteeMember } from 'app/core/model/entity-model';

@Component({
    selector: 'app-minutes-email-dialog',
    templateUrl: './minutes-email-dialog.component.html',
    styleUrls: ['./minutes-email-dialog.component.scss'],
    standalone: false,
})
export class MinutesEmailDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    attachmentArray: any;

    processing = false;
    truncatedList = false;
    committees: any;
    selectedCommitteeId: number;
    members: any[];

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private appInfo: AppInformationService, public auth: AuthService) {}

    async ngOnInit() {
        this.members = [];
        this.committees = this.uow.lookups.committees;
        this.selectedCommitteeId = Committee.Committees.ExecutiveCommittee;
        await this.getCommitteeMembers();
    }

    selectionChanged(e) {
        this.getCommitteeMembers();

    }

    async getCommitteeMembers(){
        let members = [];
        if (this.selectedCommitteeId === 1) members = _.uniqBy((await this.uow.getMembersByCommitteeIds([2, 3, 4])) as CommitteeMember[], 'personId');
        else members = (await this.uow.getMembersByCommitteeIds([this.selectedCommitteeId])) as CommitteeMember[];
        this.members = _.sortBy(members, 'person.lastName');
    }

    remove(memberId: number) {
        this.members.splice(_.findIndex(this.members, {personId: memberId}), 1)
        this.truncatedList = true;
    }


    async save(sendAsText?: boolean) {
        this.processing = true;
        const memberIds = this.members.map(x => {return x.personId})
        this.result.next({ success: true, value: this.selectedCommitteeId, memberIds: memberIds, truncatedList: this.truncatedList});
    }

    close() {
        this.processing = true;
        this.uow.rollback();
        this.result.next(false);
    }
}
